import { render } from "./DashboardReportes.vue?vue&type=template&id=1c654b90&scoped=true"
import script from "./DashboardReportes.vue?vue&type=script&lang=js"
export * from "./DashboardReportes.vue?vue&type=script&lang=js"

import "./DashboardReportes.vue?vue&type=style&index=0&id=1c654b90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c654b90"]])

export default __exports__